import { IChannelRepository } from '../../ports/IChannelRepository';

export class UpdateChannelUseCase {
  constructor(private repo: IChannelRepository) {}
  execute(uuid: string, input: { link?: string; title?: string; type?: string; isPrivate?: boolean; minimalSendingInterval?: number; sendingStartTime?: string; sendingEndTime?: string }) {
    return this.repo.update(uuid, input);
  }
}
